














































import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { formatPrice } from '@/util/format'

@Component
export default class OrderPrice extends Vue {
  @Prop({ required: true })
  totalItemCount: number

  @Prop({ required: true })
  subtotalPrice: string

  @Prop({ required: true })
  shippings: number[]

  @Prop({ default: false })
  isFreeShipping: boolean

  get totalShipping(): string {
    return formatPrice(this.isFreeShipping ? 0 : _.sum(this.shippings))
  }

  @Prop({ required: true })
  commissions: number[]

  get totalCommission(): string {
    return formatPrice(_.sum(this.commissions))
  }

  get hasCommission(): boolean {
    return this.commissions.length > 0
  }
}
